import { TalentStatusEnum } from "@/enums/talent";

export const TALENT_STATUS_LABEL: Record<TalentStatusEnum, string> = {
  [TalentStatusEnum.ACTIVE]: "Ativo",
  [TalentStatusEnum.INACTIVE]: "Inativo",
  [TalentStatusEnum.STAND_BY]: "Stand by",
};
